import { gql } from '@apollo/client';

export const RESEND_CRITICAL_ACTION_MUTATION = gql`
  mutation ResendCriticalActionMutation($input: ResendCriticalActionInput!) {
    resendCriticalAction(input: $input) {
      agentID
      action
      active
    }
  }
`;
